import { BankSEOConfig } from '../types';

const defaultConfig: BankSEOConfig = {
  fullBankName: 'default bank',
  branchOverviewPage: {
    title: 'Find medarbejdere og afdelinger',
    description:
      'Søg efter en medarbejder og find kontaktoplysninger og åbningstider.'
  },
  branchPage: {
    title: 'Åbningstider og medarbejdere',
    description:
      'Her kan du se medarbejdere, kontaktoplysninger og information om åbningstider og hæveautomater'
  },
  EmployeePage: {
    title: '',
    description: ''
  }
};

export default defaultConfig;
